import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

export default function EulaPage() {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-white pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">最终用户许可协议</h1>
            <p className="text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
              广州市星允信息技术有限公司软件产品
            </p>
          </div>
        </section>

        {/* EULA Content */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <div className="mb-8">
                <p className="text-gray-700 text-lg leading-relaxed">
                  本最终用户许可协议（"EULA"）随附广州市星允信息技术有限公司软件产品（"软件"）以及广州市星允信息技术有限公司，以下简称"广州市星允信息技术有限公司"）向您提供的所有相关说明材料及示例（"材料"）一同交付。"软件"一词还应包括软件及材料的任何升级版本、修改版本或更新版本。
                </p>
                <p className="text-gray-700 text-lg leading-relaxed mt-4">
                  本EULA与广州市星允信息技术有限公司就本软件出具的销售报价单（"报价单"）一并签订，该报价单的条款通过引用并入本协议。请在文本末尾表示接受之前，仔细阅读本EULA。如您不同意本协议条款，请在指定位置选择拒绝，您将无法获得软件的访问权限。
                </p>
              </div>

              <div className="space-y-12">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">1. 许可授予与限制</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      <strong>a.</strong> 在本EULA条款和条件的约束下，广州市星允信息技术有限公司特此授予您一项中华人民共和国范围内、非独占、不可转让的许可，许可期限为本EULA有效期，您可在报价单所列数量的服务器和处理器内核上使用本软件，并将本软件集成到您自身的应用程序中。
                    </p>
                    <p>
                      <strong>b.</strong> 如您报价单的"类型"栏注明为"SaaS"（软件即服务），则宿主应用程序可为由您通过互联网向外部用户提供的服务。
                    </p>
                    <p>
                      <strong>c.</strong> 如您报价单的"类型"栏注明为"终端用户"，则宿主应用程序可通过您自身的内部网络向您的员工提供。
                    </p>
                    <p>
                      <strong>d.</strong> 如您报价单所列软件为"表单扩展程序（Forms Extension）"，则本软件仅可用于服务器端工作流宿主应用程序中。
                    </p>
                    <p>
                      <strong>e.</strong> 未经广州市星允信息技术有限公司书面明确同意，您无权以任何形式销售、再分发、分许可或以其他方式向第三方提供本软件。
                    </p>
                    <p>
                      <strong>f.</strong> 您不得修改本软件，亦不得对仅以二进制或目标代码形式提供的任何软件进行反编译、反向汇编、拆解或以其他方式进行逆向工程，或将其还原为人类可读取的源代码。
                    </p>
                    <p>
                      <strong>g.</strong> 您可随时通过获取初始副本的同一方式，下载本软件的额外副本。
                    </p>
                    <p>
                      <strong>h.</strong> 您可制作一份本软件副本，用于备份和存档目的。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">2. 专有权利</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      <strong>a.</strong> 软件的结构和组织归广州市星允信息技术有限公司及其供应商所有，相关所有权人对软件及其商标保留独家所有权。
                    </p>
                    <p>
                      <strong>b.</strong> 您同意不删除或以任何方式更改出现在软件上或软件内的、属于广州市星允信息技术有限公司及其供应商的版权声明、商标、标识或相关声明，或其他专有权利声明。
                    </p>
                    <p>
                      <strong>c.</strong> 第三方供应商可能是软件及材料中包含的某些专有信息和知识产权的所有权人。
                    </p>
                    <p>
                      <strong>d.</strong> 软件可能包含由Adobe公司（地址：加利福尼亚州圣何塞市公园大道345号，邮编95110-2704）拥有和开发的技术，该技术依据Adobe公司与广州市星允信息技术有限公司之间的协议（"Adobe授权协议"）进行分发。
                    </p>
                    <p>
                      <strong>e.</strong> 软件可能包含来自callas软件有限公司（地址：德国柏林舍恩豪泽尔大街6/7号，邮编10119）的技术，该技术依据callas软件有限公司与广州市星允信息技术有限公司之间的协议（"callas授权协议"）进行分发。
                    </p>
                    <p>
                      <strong>f.</strong> 如Adobe授权协议或callas授权协议终止，只要您未违反本EULA的条款，您有权在本EULA剩余有效期内继续、不受中断地使用本软件。
                    </p>
                    <p>
                      <strong>g.</strong> 广州市星允信息技术有限公司及其产品名称是广州市星允信息技术有限公司的商标。其他商标是其各自商标所有权人的财产。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">3. 软件维护与支持</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      <strong>a.</strong> 广州市星允信息技术有限公司可自行决定修改软件和/或材料，并向您交付修改后的副本。
                    </p>
                    <p>
                      <strong>b.</strong> 请通过下载说明中指定的电子邮箱，向我们报告软件中疑似存在的错误。
                    </p>
                    <p>
                      <strong>c.</strong> 新版本软件发布后，广州市星允信息技术有限公司将在旧版操作系统上维护旧版本软件，维护期限为六个月（6）。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">4. 付款与定价</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      <strong>a.</strong> 您的定价和付款条款将列于报价单中。
                    </p>
                    <p>
                      <strong>b.</strong> 除非报价单中另有说明，订阅服务均按年度预付费用。
                    </p>
                    <p>
                      <strong>c.</strong> 广州市星允信息技术有限公司的银行详细信息将在发送给您的每张发票上注明。
                    </p>
                    <p>
                      <strong>d.</strong> 产品和服务的价格及费用不包含任何联邦、州、市或其他政府征收的消费税、销售税、使用税、职业税或类似税费。
                    </p>
                    <p>
                      <strong>e.</strong> 如您就某张发票向广州市星允信息技术有限公司提出争议通知，双方同意本着善意原则协商解决该争议。
                    </p>
                    <p>
                      <strong>f.</strong> 采购订单中任何与本协议条款不一致的条款均视为无效，除非经广州市星允信息技术有限公司高级管理人员书面同意。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">5. 隐私政策</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      本软件不存储任何关于用户的个人信息。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">6. 免责声明</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      广州市星允信息技术有限公司及其供应商均未就与软件相关的任何事项，向您作出任何明示、默示或法定的保证。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">7. 责任限制</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      <strong>a.</strong> 任何一方均不得在诉讼理由产生之日起两年（2）以上，就任何形式的诉讼提起诉讼。
                    </p>
                    <p>
                      <strong>b.</strong> 在任何情况下，广州市星允信息技术有限公司就本协议项下索赔向您承担的损害赔偿责任，均不得超过您在索赔发生前十二个月内就相关服务及软件实际支付的金额。
                    </p>
                    <p>
                      <strong>c.</strong> 任何一方均不对任何使用损失、业务中断，或任何间接、特殊、附带或后果性损害承担责任。
                    </p>
                  </div>
                </div>

                <div className="bg-teal-50 rounded-xl p-8 mt-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">联系我们</h2>
                  <div className="space-y-2 text-gray-700">
                    <p>
                      如果您对本最终用户许可协议有任何疑问，请通过以下方式联系我们：
                    </p>
                    <div className="mt-4 space-y-2">
                      <p><strong>邮箱：</strong> hello@documogul.com</p>
                      <p><strong>电话：</strong> 400-838-9650</p>
                      <p><strong>地址：</strong> 中国广州市天河区灵山东路5号2层</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
